module.exports = __webpack_public_path__ + "img/icon_game.fdf64a96.png";